import React, { useState } from 'react';
import { useWorldStore } from '../state/worldStore';
import { authUser } from '../config';

// AdminPanel — the single hub for the World's tuning tools. A ⚙ button (admins
// only; ?admin forces it for testing) opens a menu; picking a tool sets
// worldStore.adminTool, and exactly ONE panel / in-scene edit mode shows at a
// time (CarSizePanel, GuardPanel, PerformerPanel, NpcPlacePanel, RoutesPanel,
// CameraPanel, billboard placement). Replaces the old scattered ?<key>=edit
// panels; those params still deep-link (they seed adminTool on load).
const SHOW = (() => {
  try { return authUser().isAdmin || new URLSearchParams(window.location.search).get('admin') != null; }
  catch { return false; }
})();

// Some tools only make sense in a context; the note is just a hint (they no-op
// harmlessly elsewhere — e.g. Guard/Performer live in the concert hall).
const TOOLS = [
  { key: 'cam', label: 'Camera / spawn' },
  { key: 'cars', label: 'Car size', note: '?city=model' },
  { key: 'place', label: 'Residents', note: '?city=model' },
  { key: 'routes', label: 'Road routes', note: '?city=model' },
  { key: 'bb', label: 'Billboards', note: '?city=model' },
  { key: 'guard', label: 'Concert guard', note: '?city=model' },
  { key: 'performer', label: 'Stage performer', note: 'concert hall' },
];

const wrap = {
  position: 'fixed', left: 'max(16px, env(safe-area-inset-left))', bottom: 'max(16px, env(safe-area-inset-bottom))',
  zIndex: 50, pointerEvents: 'auto', fontFamily: 'system-ui, sans-serif',
};
const gear = {
  width: 46, height: 46, borderRadius: 999, cursor: 'pointer', fontSize: 20, lineHeight: '46px',
  background: 'rgba(16,10,6,0.85)', border: '1px solid rgba(255,178,94,0.5)', color: '#ffd27d',
  backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)', textAlign: 'center', padding: 0,
};
const menu = {
  marginBottom: 8, width: 184, background: 'rgba(16,10,6,0.92)', border: '1px solid rgba(255,178,94,0.4)',
  borderRadius: 12, padding: '8px 8px 10px', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
};

export default function AdminPanel() {
  const tool = useWorldStore((s) => s.adminTool);
  const setTool = useWorldStore((s) => s.setAdminTool);
  const [open, setOpen] = useState(false);
  if (!SHOW) return null;

  return (
    <div style={wrap}>
      {open && (
        <div style={menu}>
          <div style={{ fontSize: 10.5, letterSpacing: 1.3, textTransform: 'uppercase', opacity: 0.7, color: '#ffd27d', margin: '2px 4px 8px' }}>
            World tools
          </div>
          {TOOLS.map((t) => {
            const on = tool === t.key;
            return (
              <button
                key={t.key}
                onClick={() => setTool(t.key)}
                style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%',
                  margin: '3px 0', padding: '8px 9px', borderRadius: 8, cursor: 'pointer', font: '600 12.5px system-ui',
                  border: '1px solid rgba(255,178,94,0.3)', textAlign: 'left',
                  background: on ? '#ffb25e' : 'rgba(255,178,94,0.1)', color: on ? '#1c1206' : '#ffe9c4',
                }}
              >
                <span>{t.label}</span>
                {t.note && <span style={{ fontSize: 9.5, opacity: on ? 0.7 : 0.45 }}>{on ? 'active' : t.note}</span>}
              </button>
            );
          })}
          <div style={{ fontSize: 10, opacity: 0.55, color: '#ffe9c4', margin: '6px 4px 0', lineHeight: 1.4 }}>
            Tap a tool to open its panel; tap it again to close.
          </div>
        </div>
      )}
      <button onClick={() => setOpen((o) => !o)} title="World admin" style={gear}>⚙</button>
    </div>
  );
}
